import { createSlice } from "@reduxjs/toolkit";
import { startTransition } from "react";
export const assignToAgentsSlice = createSlice({
	name: "assignToAgents",
	initialState: {
		searchData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: "-1",
			partnerId: "-1",
			partnerBranchId: "-1",
		},
		addPartnerAgentAssignmentData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			partnerBranchAssignmentId: "-1",
			partnerAgentId: [],
		},
		agentList: [],
		partnerAgentAssignmentsByLockersData: [],
		lockerTypeList: [],
		partnerList: [],
		branchList: [],
	},
	reducers: {
		getPartnerList: (state, actions) => {
			state.partnerList = actions.payload;
		},
		getBranchList: (state, actions) => {
			state.branchList = actions.payload;
		},
		getLockerTypeList: (state, actions) => {
			state.lockerTypeList = actions.payload;
		},
		getAgentList: (state, actions) => {
			state.agentList = actions.payload;
		},
		getpPartnerAgentAssignmentsByLockers: (state, actions) => {
			state.partnerAgentAssignmentsByLockersData = actions.payload;
		},
		handleAddPartnerAgentAssignmentData: (state, actions) => {
			const { name, value } = actions.payload;
			switch (name) {
				case "partnerBranchAssignmentId":
					return {
						...state,
						addPartnerAgentAssignmentData: {
							...state.addPartnerAgentAssignmentData,
							partnerBranchAssignmentId: value,
						},
					};

				case "partnerAgentId":
					return {
						...state,
						addPartnerAgentAssignmentData: {
							...state.addPartnerAgentAssignmentData,
							partnerAgentId: value,
						},
					};
			}
		},
		handleOnChanged: (state, actions) => {
			const { name, value } = actions.payload;
			switch (name) {
				case "lockerTypeId":
					return {
						...state,
						searchData: {
							...state.searchData,
							lockerTypeId: value,
						},
					};
				case "partnerId":
					return {
						...state,
						searchData: {
							...state.searchData,
							partnerId: value,
						},
					};
				case "partnerBranchId":
					return {
						...state,
						searchData: {
							...state.searchData,
							partnerBranchId: value,
						},
					};
				default:
					break;
			}
		},
		clearSearchData: (state, actions) => {
			state.searchData = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lockerTypeId: "-1",
				partnerId: "-1",
				partnerBranchId: "-1",
			};
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getPartnerList,
	getBranchList,
	getLockerTypeList,
	getpPartnerAgentAssignmentsByLockers,
	handleAddPartnerAgentAssignmentData,
	getAgentList,
	handleOnChanged,
	clearSearchData,
	handleAssignedBranchLockerData,
} = assignToAgentsSlice.actions;

export default assignToAgentsSlice.reducer;
